export default "__VITE_ASSET__724168aa__"